export default {
  common: {
    select: '選択',
    form: {
      addFile: 'ドラッグ＆ドロップまたはファイルを追加',
      chooseFile: 'ファイルを選択',
      noFileSelected: 'ファイルが選択されていません',
      select: '選択',
      choose: '選択してください...',
      downloadFile: 'ダウンロード',
      error: {
        email: '有効なメールアドレスを入力してください',
        required: 'この項目は必須です',
        minCharacters: '{{length}}文字',
        oneLowerCase: '小文字1文字',
        oneUpperCase: '大文字1文字',
        oneNumber: '数字1文字',
        passwordMustContain: `パスワードには少なくとも\${items}が必要です。`,
        passwordMustMatch: 'パスワードが一致しません',
        and: 'と',
        fileTooLarge: 'ファイルが大きすぎます：最大サイズ {{size}}MB',
      },
    },
    header: {
      nav: {
        home: 'ホーム',
        signin: 'ログイン',
        signup: '新規登録',
        signout: 'ログアウト',
      },
    },
    subheader: {
      date: '2024年9月24日',
      location: 'オーストラリア、シドニー',
    },
    footer: 'お問い合わせ',
    congratulation: 'おめでとうございます',
    footer_text: 'フッターテキスト（太字）',
    email_1: '連絡先メール1（リンク付き）',
    email_2: '連絡先メール2（リンク付き）',
  },
};
